import {Inject, Injectable} from '@angular/core';
import {Po2024Service} from './po-2024.service';

@Injectable({
  providedIn: 'root'
})
export class PoMetaService {

  constructor(
    @Inject('above_default') private abovePoService: Po2024Service,
    @Inject('vod_default') private vodDefaultPoService: Po2024Service,
    @Inject('vod_repackaging') private vodRepackagingPoService: Po2024Service,
    @Inject('vod_display_interactive') private vodDisplayInteractivePoService: Po2024Service,
    @Inject('vod_passthrough_sffw') private vodPassthroughPoService: Po2024Service,
  ) {
  }

  get poService(): Po2024Service {
    return [
      this.abovePoService,
      this.vodDefaultPoService,
      this.vodRepackagingPoService,
      this.vodDisplayInteractivePoService,
      this.vodPassthroughPoService,
    ].find(v => v.active)
  }

  setActive(serviceName: string) {
    this.abovePoService.active = serviceName === 'above_default'
    this.vodDefaultPoService.active = serviceName === 'vod_default'
    this.vodRepackagingPoService.active = serviceName === 'vod_repackaging'
    this.vodDisplayInteractivePoService.active = serviceName === 'vod_display_interactive'
    this.vodPassthroughPoService.active = serviceName === 'vod_passthrough_sffw'
  }



}
